var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"nav-menu"},_vm._l((_vm.menus),function(item,index){return _c('span',{key:index,class:{ active: _vm.activeIndex === index },on:{"click":function($event){return _vm.setActive(index)}}},[_vm._v(_vm._s(_vm.i18n.navbar[item.title]))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d02eecd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/desktop/NavBar.vue
// module id = null
// module chunks = 